import { Box, Button, Typography } from "@mui/material";
import { gameArray } from "../../utils/gameArrat";
import { getNiceCoins } from "../../utils/function";
import { Link } from "react-router-dom";

const GameList = ({ isMobile }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
        >
            {
                gameArray.map((game, index) => {

                    const exchane = getNiceCoins(game['server'][0]['rate'])
                    

                    return (
                        <Box
                            key={index}
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={1}
                            p={2}
                            sx={{
                                backgroundColor: '#2e2e2e',
                                borderRadius: '10px',
                                padding: 2,
                                width: '100%',
                                cursor: 'pointer',
                                transition: 'background-color 0.3s',
                                '&:hover': {
                                    backgroundColor: '#3e3e3e'
                                }
                            }}
                        >
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={isMobile ? 1 : 2}
                            >
                                <Box sx={{ borderRadius: '10px', width: isMobile ? 40 : 80, height: isMobile ? 40 : 80, backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={`/images/${game.logo}`} alt={game.name} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                </Box>
                                <Typography variant={isMobile ? "body1" : "h6"}>{game.label}</Typography>
                            </Box>

                            <Box
                                display="flex"
                                alignItems="center"
                                gap={2}
                            >
                                <Typography mb={0} variant={isMobile ? "body2" : "body1"} color="textSecondary">
                                    {exchane.coins + ' ~ ' + exchane.usd + ' руб'}
                                </Typography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size={isMobile ? "small" : "medium"}
                                    component={Link}
                                    to={'/game/' + game.path}
                                >
                                    Купить
                                </Button>
                            </Box>

                        </Box>
                    )



                })
            }
        </Box>
    );
};

export default GameList;